// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1HFKB","requiredAsterisk":"Info_requiredAsterisk__pZiV1"};